import {
  LEAD_ASSIGNABLE_ROLES,
  resolveViewerScope,
  type CrmRole,
  type LeadAssignmentPolicy,
} from "@school-sales-ai/shared";
import type { MultiSelectOption } from "@/components/MultiSelectFilter";

/** The "unassigned" bucket — same sentinel the server's listClause reads. */
export const UNASSIGNED = "none";

/**
 * The options this viewer can usefully pick. An unrestricted viewer sees the
 * whole team; a restricted one (a member, or an admin under «solo sus propios
 * prospectos») can only ever see their own leads and, when their scope includes
 * it, the unassigned pool — offering teammates would only produce empty results.
 */
export function assigneeFilterOptions(
  policy: LeadAssignmentPolicy,
  viewer: { id: string; role: CrmRole },
): MultiSelectOption[] {
  const unassigned: MultiSelectOption = { id: UNASSIGNED, name: "Sin asignar" };
  const scope = resolveViewerScope(policy, viewer);
  if (scope === null) {
    const team = policy.members
      .filter((m) => m.active && LEAD_ASSIGNABLE_ROLES.includes(m.role))
      .map((m) => ({ id: m.id, name: m.name }));
    return [unassigned, ...team];
  }
  const mine: MultiSelectOption = { id: viewer.id, name: "Mis prospectos" };
  return scope.includeUnassigned ? [mine, unassigned] : [mine];
}
